// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-post-post-js": () => import("./../src/templates/Post/Post.js" /* webpackChunkName: "component---src-templates-post-post-js" */)
}

